export enum QuickBindCardStatusEnum {
  /** 数据加载中 */
  LOADING = 'loading',
  /** 用户选择银行中 */
  SELECTING = 'selecting',
  /** 用户已选择银行(未提交订单) */
  SELECTED = 'selected',
  /** 银行绑卡中(已提交订单) */
  BINDING = 'binding',
  /** 绑卡成功 */
  COMPLETE = 'complete'
}

export interface BoundOrderData {
  accountNo: string,
  bindRequestNo: string,
  cardApplyId: string
}

export interface QuickBindCardResult {
  bankId: string,
  bankNo: string,
  bankName?: string,
  bankLogo?: string,
}
